// extracted by mini-css-extract-plugin
export default {"root":"FN4U_mnDCa0JLX_tXqZB","single-col":"t9aOyzX8R5fVJhqvFrLt","singleCol":"t9aOyzX8R5fVJhqvFrLt"};